export default __webpack_public_path__ + "assets/icons/collect.a1fab2cb.svg";